
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/create",
      function () {
        return require("private-next-pages/brands/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/create"])
      });
    }
  